// extracted by mini-css-extract-plugin
export default {"container":"bRRoDwBA0_4eYmdLvw9E"};